import * as React from 'react';
import { toast } from 'react-toastify';
import type { GenericList } from './models/JobSharedInterfaces';
import { CheckPermissions, GetQuery, PostFormDataQuery } from './Shared';
import { useNavigate } from 'react-router-dom';

const ItemPhotoData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [itemTypeOptions, setItemTypeOptions] = React.useState<GenericList[]>([]);
    const [itemTypeId, setItemTypeId] = React.useState(-1);
    const [uploadedFiles, setUploadedFiles] = React.useState<File[]>([]);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("CreateEditAdminLists");
        if (hasPermission) {
            getItemTypes();
        } else {
            navigate("/accessdenied");
        }
    }

    const getItemTypes = async () => {
        const apiUrl = "GetItemTypes";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setItemTypeOptions(result.data.itemTypeOptions);
            setLoading(false);
        } 
    }

    const clearError = (errorItem: string) => {
        let errorList = errors;
        delete errorList[errorItem];

        setErrors(errorList);
    }

    const handleImportFile = (e: any) => {
        setUploadedFiles(e.target.files);
    }

    const importPhotos = () => {
        let errorList: any = {};

        if (itemTypeId < 0) {
            errorList["itemTypeId"] = "Item Type is Required!";
            setErrors(errorList);
        }
        else if (uploadedFiles.length === 0) {
            errorList["photo"] = "Photo is Required!";
            setErrors(errorList);
        } else {
            importJobPhotos();
        }
    }

    const importJobPhotos = async () => {
        var uploadedFile = uploadedFiles[0];

        //save photos
        const filedata = new FormData()
        filedata.append('ItemTypeId', itemTypeId.toString());
        filedata.append('files', uploadedFile);

        const apiUrl = "SaveItemPhoto";
        var result = await PostFormDataQuery(apiUrl, filedata);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Photo has been uploaded");
            }
        }
    }
    
    const renderDetails = (
        <div>
            <label className="input-group" htmlFor="contact">
            <span className="label">Item Type</span>
                <select className="select" id="itemTypeId" name="itemTypeId" value={itemTypeId} onChange={(e) => { clearError(e.target.name); setItemTypeId(Number(e.target.value)) } }>
                <option hidden defaultValue="-1"></option>
                {itemTypeOptions.map(item =>
                    <option key={item.id} value={item.id}>{item.name}</option>
                    )};
                </select>
            </label>
            <span className="label errors">{errors["itemTypeId"]}</span>

            <div className="marginTop10 marginBottom10">
                <input className="marginLeftLabel" type="file" name="file" accept="image/*" onChange={handleImportFile} />
            </div>
            <span className="label errors">{errors["photo"]}</span>

            <button className="defaultbutton marginLeftLabel" type="button" onClick={importPhotos}>Save</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return <div>
        <h1>Item Formulas</h1>
        {contents}
    </div>;
}

export default ItemPhotoData;